import { Component, OnInit } from '@angular/core';
import { LanguagesService } from "src/app/services/languagesService/languages.service";

import { TagsService } from 'src/app/services/tags/tags.service';

@Component({
  selector: 'app-history-points',
  templateUrl: './history-points.page.html',
  styleUrls: ['./history-points.page.scss'],
})
export class HistoryPointsPage implements OnInit {

  constructor(public languageService: LanguagesService,
    private tagsService:TagsService) {}

  ngOnInit() {
    console.log("gola");
    this.tagsService.setEventTag('points_page','points_screen_viewed',false,true);
  }

  get getTextsIUPageHistoryPoints() {
    return this.languageService.textsIU.page_history_points;
  }
}
